import { useEffect } from 'react';
import axios from 'axios';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { getHeaderConfigThunk } from 'state/header-config/header-config-thunks';
import { selectData } from 'state/header-config/header-config-slice';
import { selectIsLoggedIn } from 'state/authentication/authentication-slice';

import localPrimary from '../config/primary.json';
import localSecondary from '../config/secondary.json';

const accountMenu = (isLoggedIn, quickLinks = []) => {
  // ugly mimicking nsx-header functionality ... but this what we're left to resort too unfortunatelly just to have a custom logo
  if (!isLoggedIn) {
    return [
      {
        heading: 'Account',
        href: '/identity',
        icon: 'user-outline',
        banner: {
          link: {
            href: '/identity',
            text: 'Log in'
          }
        },
        links: quickLinks[0] ?? []
      }
    ];
  }

  return [
    {
      heading: 'Account',
      href: '/identity',
      icon: 'user',
      banner: {
        link: {
          href: '/identity/#/logout',
          text: 'Log out'
        }
      },
      links: quickLinks[1] ?? []
    }
  ];
};

export const useSections = () => {
  const dispatch = useDispatch();
  const headerConfig = useSelector(selectData, shallowEqual);
  const isLoggedIn = useSelector(selectIsLoggedIn, shallowEqual);

  useEffect(() => {
    const source = axios.CancelToken.source();
    const requestConfig = { cancelToken: source.token };

    const callApis = async () => {
      try {
        await dispatch(getHeaderConfigThunk({ requestConfig }));
      } catch (e) {
        return e && console.error(e);
      }
    };

    callApis();

    return async () => {
      await source.cancel();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Ugly using local header config for dual branded journeys but it will have
  // to do until we can convince Nucleus to allow nsx-header logo customisation
  const primary = localPrimary
    .map((item, index) => {
      const subheadings = headerConfig?.sections?.[index];

      item.subheadings = subheadings || [];

      return item;
    })
    .filter((subheadings) => subheadings);

  const nsHeaderQuickLinks = accountMenu(
    isLoggedIn,
    headerConfig['quick-links']
  );

  return {
    primary,
    secondary: localSecondary,
    sections: headerConfig.sections,
    menuBanner: headerConfig['menu-banner'],
    secondaryBanner: headerConfig['secondary-banner'],
    nsxHeaderQuickLinks: headerConfig['quick-links'],
    nsHeaderQuickLinks,
    hideA11yBtn: headerConfig.hideA11yBtn
  };
};
